import { AnalysisFeature, AnalysisFeatureProps } from './AnalysisFeature';

interface AnalysisFeatureGroupProps {
  features: Omit<AnalysisFeatureProps, 'itemNumber'>[];
}

export const AnalysisFeatureGroup = ({ features }: AnalysisFeatureGroupProps): React.ReactElement => (
  <>
    {features.map((feature, index) => (
      <AnalysisFeature {...feature} key={feature.id} itemNumber={index + 1}></AnalysisFeature>
    ))}
  </>
);
